import {
  AUTH_ERROR,
  CHANGE_STEP,
  CONTRACT_ID,
  CONTRACT_NUMBER,
  CONTRACTS,
  CURRENT_NOTIFICATION_DATA,
  CURRENT_NOTIFICATION_INDEX,
  DEAD_LOCK_MESSAGE,
  IS_ASSIGNED,
  IS_DEAD_LOCK,
  IS_SHOW_ELECTRONIC_CONSENTS_DETAIL,
  IS_SHOW_NOTIFICATIONS_DETAIL,
  IS_SHOW_ZET_LESSON_DETAIL,
  LSS_BLOCK_NOTIFICATION_DATA,
  NOTIFICATIONS_COUNT,
  NOTIFICATIONS_SUMMARIES,
  RESET_NOTIFICATIONS,
  RESET_STORE,
  SET_IS_VALID_LOGIN,
  SET_MENU,
  SET_TOKEN,
  VUZ_ID,
  ZET_LESSON_DETAIL_DATA,
} from "../types";

export const setInvalidLoginAction = (value) => async (dispatch) => {
  dispatch({ type: SET_IS_VALID_LOGIN, payload: value });
};
export const setTokenAction = (value) => async (dispatch) => {
  dispatch({ type: SET_TOKEN, payload: value });
};
export const notificationsCountAction = (value) => async (dispatch) => {
  dispatch({ type: NOTIFICATIONS_COUNT, payload: value });
  if (value.dead_lock) {
    dispatch({ type: DEAD_LOCK_MESSAGE, payload: value.dead_lock_text });
    dispatch({ type: IS_DEAD_LOCK, payload: true });
  }
};

export const notificationsSummariesAction = (value) => async (dispatch) => {
  dispatch({ type: NOTIFICATIONS_SUMMARIES, payload: value });
};
export const contractIdAction = (value) => async (dispatch) => {
  dispatch({ type: CONTRACT_ID, payload: value });
};
export const contractsAction = (value) => async (dispatch) => {
  dispatch({ type: CONTRACTS, payload: value });
};
export const contractNumberAction = (value) => async (dispatch) => {
  dispatch({ type: CONTRACT_NUMBER, payload: value });
};
export const currentNotificationAction = (value) => async (dispatch) => {
  dispatch({ type: CURRENT_NOTIFICATION_DATA, payload: value });
};
export const showNotificationDetailAction = (value) => async (dispatch) => {
  dispatch({ type: IS_SHOW_NOTIFICATIONS_DETAIL, payload: value });
};
export const showElectronicConsentsDetailAction =
  (value) => async (dispatch) => {
    dispatch({ type: IS_SHOW_ELECTRONIC_CONSENTS_DETAIL, payload: value });
  };
export const lssBlockNotificationDataAction = (value) => async (dispatch) => {
  dispatch({ type: LSS_BLOCK_NOTIFICATION_DATA, payload: value });
  // dispatch({ type: IS_SHOW_NOTIFICATIONS_DETAIL, payload: true });
};
export const currentNotificationIndexAction = () => async (dispatch) => {
  dispatch({ type: CURRENT_NOTIFICATION_INDEX });
};
export const showZetLessonDetailAction = (value) => async (dispatch) => {
  dispatch({ type: IS_SHOW_ZET_LESSON_DETAIL, payload: value });
};
export const zetLessonDetailDataAction = (value) => async (dispatch) => {
  dispatch({ type: ZET_LESSON_DETAIL_DATA, payload: value });
};
export const deadLockAction = (value) => async (dispatch) => {
  dispatch({ type: IS_DEAD_LOCK, payload: value });
};
export const assignAction = (value) => async (dispatch) => {
  dispatch({ type: IS_ASSIGNED, payload: value });
};
export const vuzIdAction = (value) => async (dispatch) => {
  dispatch({ type: VUZ_ID, payload: value });
};
export const setMenuAction = (value) => async (dispatch) => {
  dispatch({ type: SET_MENU, payload: value });
};
export const resetStore = () => ({
  type: RESET_STORE,
});
export const resetNotifications = () => ({
  type: RESET_NOTIFICATIONS,
});
export const authErrorAction = (value) => async (dispatch) => {
  dispatch({ type: AUTH_ERROR, payload: value });
};
export const changeStepAction = (value) => async (dispatch) => {
  dispatch({ type: CHANGE_STEP, payload: value });
};
